import Footer from "../../footer"
import NavBar from "../../nav"

const ComplianceManagement = () => {
  return <div>
    <NavBar />
    <div className='compliance-management'>
    <section className="clean-block pfa-content clearfix">
			<div className="divider sections">
				<h1>Compliance Management</h1>
				<div className="headline-divider sections"></div>
				<h2>Compliance Assistance Program</h2>
				<h3>Providing assistance in all areas of operations.</h3>
			</div>
		</section>
    <section className="clean-block clearfix">
			<div className="container content-container">		
				<div className="prose">Fly Compliant, LLC has developed a system to assist Part 119 managers or Part 91 operators to manage all aspects of any size flight department. It's called the Compliance Assistance Program (CAP). CAP is a means of leveraging our expertise for your operation. Our technical analysis will review your data (both aircraft and airman) to determine compliance in all areas. The CAP provides operators additional support at a fraction of the cost with no need to train on the system. The CAP is a low cost and efficient means of maintaining compliance in real-time.</div>	
			</div>			
			<div className="container content-container square-container">	
				<div className="grid-1 callout">
					<div className="prose-header">Manual System</div>
					<div className="prose">Fly Compliant, LLC provides a manual system for any size operation, including:</div>
					<div className="prose">
						<ul>
							<li>General Operations Manual</li>
							<li>General Maintenance Manual</li>
							<li>Compliance Statement</li>
							<li>Training Program</li>
							<li>Category II and IIIb Manuals</li>
							<li>Safety Management System</li>
							<li>Minimum Equipment List</li>
							<li>Reduced Vertical Separation Manual</li>
							<li>Compliance Statement</li>
							<li>Hazardous Material Manual (Carriage and Non-Carriage)</li>
							<li>Flight Attendant Manual</li>
							<li className="last-bullet">International Procedures Manual</li>
						</ul>
					</div>	
				</div>
				<div className="grid-2 callout">
					<div className="prose-header">FAA Liaison</div>
					<div className="prose">FAA Liaison services include working directly with FAA inspectors and performing the following services:</div>
					<div className="prose">
						<ul>
							<li>Complete Certifications Services</li>
							<li>Certificate Upgrade Service</li>
							<li>Oceanic and International Expansion</li>
							<li>SMS Voluntary Program</li>
							<li>ASAP</li>
							<li>WebOPSS</li>
							<li>OAPS</li>
							<li>LOA Applications</li>
							<li>Manual Revisions</li>
							<li className="last-bullet">CASS</li>
						</ul>
					</div>
				</div>
			</div>
			<div className="container content-container square-container">		
				<div className="grid-1 callout">
					<div className="prose-header">Digital Operations Management</div>
					<div className="prose">We have created LevelFlight.com as a complete electronic record keeping and operations management system with the regulations built into the software. LevelFlight is a cloud-based software-as-a-service (SaaS) delivered to any Web enabled device. LevelFlight is the first only compliance focused platform designed to provide:</div>	
					<div className="prose">
						<ul>
							<li>Scheduling</li>
							<li>Compliant Dispatching</li>
							<li>Flight Release compliant with 135.23(e)</li>
							<li>Recordkeeping per OpSpecs (A025)</li>
							<ul>
								<li>Airman</li>
								<li>Aircraft</li>
							</ul>
							<li>Reporting</li>
							<li>SMS Platform</li>
						</ul>
					</div>			
					<div className="prose">As a complete service, LevelFlight provides integration with:</div>	
					<div className="prose">
						<ul>
							<li>Avinode</li>
							<li>Quickbooks</li>
							<li>CAMP</li>
							<li>E-APIS</li>
							<li>TSA</li>
							<li>FlightBridge</li>
							<li className="last-bullet">Fueler Linx</li>
						</ul>
					</div>
				</div>
				<div className="grid-2 callout">
					<div className="prose-header">Risk Managment</div>
					<div className="prose">Fly Compliant, LLC has incorporated a comprehensive Safety Management System (SMS) and the first platform with a real-time objective Automated Risk Assessment (ARA). We have developed a Safety Standard describing all the elements of the ARA, providing the user with an objective assessment of each flight, along with audit to see what are the risk factors.</div>
					<div className="prose">As Part of Risk Management system we offer.</div>
					<div className="prose">
						<ul>
							<li>Automated Risk Assessment</li>
							<li>Internal Evaluation Program</li>
							<li>Safety Meetings</li>
							<li>CASS Meetings</li>
							<li>Tracking of safety events including:</li>
							<ul>
								<li>Maintenance</li>
								<li>Dispatch</li>
								<li>Change Management</li>
								<li>Maintenance Providers</li>
							</ul>
						</ul>
					</div>						
				</div>	
			</div>		
		</section>
    </div>
    <Footer />
  </div>
}

export default ComplianceManagement